import { createSlice } from "@reduxjs/toolkit";

const accessToken = localStorage.getItem("accessToken");
const refreshToken = localStorage.getItem("refreshToken");

const initialState = {
    accessToken: accessToken,
    refreshToken: refreshToken,
    isAuthenticated: Boolean(accessToken),
};

const authSlice = createSlice({
    name: "auth",
    initialState,

    reducers: {
        login: (state, action) => {
            const { accessToken, refreshToken } = action.payload;

            state.accessToken = accessToken;
            state.refreshToken = refreshToken;
            state.isAuthenticated = true;

            localStorage.setItem("accessToken", accessToken);
            localStorage.setItem("refreshToken", refreshToken);
        },

        logout: (state) => {
            state.accessToken = null;
            state.refreshToken = null;
            state.isAuthenticated = false;

            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("user");
            localStorage.removeItem("registerData");
            localStorage.removeItem("username");
            localStorage.removeItem("startDate");
            localStorage.removeItem("endDate");
            localStorage.removeItem("phoneNumber");
            localStorage.removeItem("countryCode");
            localStorage.removeItem("logo");
        },
    },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;